import React, { useState, useEffect, useRef } from 'react';
import { fetchAvailableAttributes } from '~/modules/Bidders/api';
import { Button } from '~/components/Button';
import style from './index.module.scss';

const getExample = (attribute, op) => {
    switch (attribute.type) {
        case 'string':
        case 'set':
            if (op === 'in' || op === 'not in') return '["value1", "value2"]';
            if (op === 'contains' || op === 'not contains') return '"value1"';
            return '"value1"';
        case 'numeric':
            if (op === 'in' || op === 'not in') return '[123, 456]';
            return '123';
        case 'bool':
            return 'true';
        case 'version':
            if (op === 'in' || op === 'not in') return '["1.0.0", "2.0.0"]';
            return '"1.0.0"';
        default:
            return '"example"';
    }
};

const copyToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
    } catch (e) {
    }
};

interface IAvailableAttributesProps {
    align?: 'left' | 'right';
    className?: string;
}

const AvailableAttributes: React.FC<IAvailableAttributesProps> = ({align = 'right', className}) => {
    const [isPanelVisible, setIsPanelVisible] = useState(false);
    const [attributes, setAttributes] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        const loadAttributes = async () => {
            const data = await fetchAvailableAttributes();
            setAttributes(data);
            setIsLoading(false);
        };

        loadAttributes();
    }, []);

    const togglePanel = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsPanelVisible(!isPanelVisible);
    };

    const [copiedText, setCopiedText] = useState<string | null>(null);

    const timerRef = useRef<number | null>(null);

    const handleOperatorClick = (attribute, op) => {
        const example = getExample(attribute, op);
        const code = `${attribute.name} ${op} ${example}`;
        copyToClipboard(code);
        setCopiedText(`Copy: ${code}`);

        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = window.setTimeout(() => {
            setCopiedText(null);
            timerRef.current = null;
        }, 2000);
    };
    return (
        <div className={className}>
            <div className={style.showText} style={{textAlign: align}}>
                <span className={style.showTextBtn} onClick={togglePanel}>
                    {isPanelVisible ? 'Close Available Attributes' : 'Show Available Attributes'}
                </span>
            </div>
            <div className={`${style.sidePanel} ${isPanelVisible ? style.visible : ''}`}>
                <div className={style.panelHeader}>Available Attributes</div>
                <div className={style.attributeContent}>
                    {isLoading ? (
                        <div>Loading...</div>
                    ) : (
                        <div className={style.attributeList}>
                            <div className={style.attributeListHeader}>
                                <span className={style.attributeInfo}><strong></strong></span>
                                <span className={style.attributeType}><strong>Type:</strong></span>
                                <span className={style.attributePriority}><strong>Priority:</strong></span>
                            </div>
                            {attributes.map((attribute, index) => (
                                <div key={index} className={style.attributeCard}>
                                    <span className={style.attributeInfo}>
                                        <span><strong>{attribute.name}</strong></span>
                                        <div>{attribute.label}</div>
                                        {attribute.ops && attribute.ops.length > 0 && (
                                            <div className={style.cardOps}>
                                                {attribute.ops.map((op) => (
                                                    <span
                                                        key={op}
                                                        className={style.operator}
                                                        onClick={() => handleOperatorClick(attribute, op)}
                                                    >
                                                        {op}
                                                    </span>
                                                ))}
                                            </div>
                                        )}
                                    </span>
                                    <span className={style.attributeType}>
                                        <span>{attribute.type}</span>
                                    </span>
                                    <span className={style.attributePriority}>
                                        <span>{attribute.priority}</span>
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <div className={style.panelFooter}>
                    <div className={style.containerToast}>
                        <div className={`${style.toast} ${copiedText ? style.toastVisible : ''}`}>
                            {copiedText}
                        </div>
                    </div>
                    <Button onClick={togglePanel} className={style.closeButton}>
                        Close
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default AvailableAttributes;
